import * as v from '@badrap/valita'
import { createStorageCategory } from 'src/storage'

const createSessionStorage = createStorageCategory('session', 'ACTIVE_USERS')

export const savedActiveUserQuery = createSessionStorage('query', v.string())
